export const SAUDI_IBAN_LENGTH = 24;

export const formatIbanForDisplay = (value) => {
  if (!value) return '';
  const cleaned = String(value).replace(/\s/g, '').toUpperCase();
  return cleaned.replace(/(.{4})/g, '$1 ').trim();
};

export const validateSaudiIban = (value, required = false) => {
  const cleaned = (value || '').replace(/\s/g, '').toUpperCase();
  if (!cleaned) return required ? 'الآيبان مطلوب' : null;
  if (!cleaned.startsWith('SA')) return 'يجب أن يبدأ الآيبان بـ SA';
  if (cleaned.length !== SAUDI_IBAN_LENGTH) return `الآيبان يجب أن يكون ${SAUDI_IBAN_LENGTH} حرفاً (SA + 22 رقم)`;
  if (!/^SA[0-9]{22}$/.test(cleaned)) return 'الآيبان يحتوي أحرفاً غير صالحة';
  return null;
};

export const hasValidSaudiIban = (iban) => !validateSaudiIban(iban, true);

export const cleanIban = (iban) => (iban || '').replace(/\s/g, '').toUpperCase();
